import React, { useState, useEffect } from "react";
import Modal from "@components/ModalTemplate";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import Button from "@components/Button";
import SectionHeader from "../SectionHeader";
import { useNavigate } from "react-router";
import "./style.scss";
import { fetchData } from "@app/Helpers";

export default NiceModal.create(() => {
  const modal = useModal();
  const navigate = useNavigate();

  async function sendConsent(userConsent) {
    fetchData({
      endpoint: "/activation/passport/vusetokiohotel2025/spin",
      payload: { consent: userConsent },
      successCallback: () => {
        modal.hide();
      },
    });
  }

  return (
    <Modal
      isOpen={modal.visible}
      onClose={() => {
        modal.hide();
      }}
      onAfterClose={() => modal.remove()}
      innerClass={"quiz-13-modal"}
      disableClose={true}
    >
      <>
        <SectionHeader>
          <strong>Tokio Hotel x Vuse Gewinnspiel</strong>
        </SectionHeader>
        <div className="copy">
          <p className="award-name">
            <strong>5x Tokio Hotel Fleecepullover</strong>
          </p>
          <p className="award-name">
            <strong>5x Tokio Hotel Mütze und Schal</strong>
          </p>
          <p className="logos-header">
            Klicken und an der Verlosung der Tokio Hotel Preise teilnehmen!
          </p>
        </div>
        <div className="buttons-wrapper">
          <Button
            action={() => {
              sendConsent(true);
            }}
          >
            Teilnehmen
          </Button>
          <Button
            action={() => {
              sendConsent(false);
            }}
          >
            Kein Interesse
          </Button>
        </div>
      </>
    </Modal>
  );
});
